import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_FlowchartPaper_Button_Interface, FlowchartPaper_Button_Interface } from 'src/app/Interface/FlowchartPaper_Button_Interface';
import { Empty_FlowchartPaper_History_Interface, FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from 'src/app/Interface/FlowchartPaper_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { FlowchartService } from 'src/app/Service/Flowchart/Flowchart.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FlowchartInbox',
  templateUrl: './FlowchartInbox.component.html',
  styleUrls: ['./FlowchartInbox.component.css']
})
export class FlowchartInboxComponent implements OnInit {

  Token: String = ""
  PaperDsc: string = ""
  Fullname_Filter: string = ""
  page: number = 0;
  Procssing: boolean = false
  ProcssingAction: boolean = false

  BaseUrl1:string=""
  LetterNumber_Filter:string=""
  Form_Filter:string="0"
  BaseUrlCo:string="&id2="

  modalRef_Action: any;

  constructor(
    private FlowcharPaper_Service: FlowcharPaperService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private Flowchart_Service: FlowchartService,
    private modalService: BsModalService
  ) { }

  DataList_Paper: Array<FlowchartPaper_Interface> = []
  DataList_Form: Array<General_Interface> = []

  Data_Seleted_Record: FlowchartPaper_Interface = Empty_FlowchartPaper_Interface()
  Data_Seleted_Button: FlowchartPaper_Button_Interface = Empty_FlowchartPaper_Button_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/WorkflowDetail?token="+this.Token+"&id="
    this.Nav_Service.CheckValidPage(this.Token, 2200).subscribe(
      data => {
        this.ReadData_Form()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Form() {
    this.Procssing = true
    this.Flowchart_Service.GetForm(this.Token,).subscribe(
      data => {
        this.DataList_Form = data
        this.Procssing = false
        this.ReadData_Paper()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Paper() {
    this.Procssing = true
    this.FlowcharPaper_Service.Read_Inbox(this.Token,this.LetterNumber_Filter,Number(this.Form_Filter)).subscribe(
      data => {
        this.DataList_Paper = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Set_Data_Seleted_Record(item:FlowchartPaper_Interface)
  {
    this.Data_Seleted_Record=item
  }

  Reset_Data_Seleted_Record(){
    this.Data_Seleted_Record = Empty_FlowchartPaper_Interface()
  }

  Show_Data_Seleted_Record(template: TemplateRef<any>, item: FlowchartPaper_Button_Interface) {
    this.Data_Seleted_Button = item
    this.modalRef_Action = this.modalService.show(template)
    this.PaperDsc=""
  }


  Inbox_Action() {
    this.modalRef_Action.hide()
    this.ProcssingAction=true
    this.FlowcharPaper_Service.Inbox_Action(this.Token,
      this.PaperDsc,
      this.Data_Seleted_Record.makerId,
      this.Data_Seleted_Button.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Information saved successfully.")
        this.ReadData_Paper()
        this.Reset_Data_Seleted_Record()
        this.ProcssingAction = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  DataList_History:Array<FlowchartPaper_History_Interface>=[]
  Selected_History_Record:  FlowchartPaper_Interface=Empty_FlowchartPaper_Interface();
  ReadData_History(item:FlowchartPaper_Interface){
    this.Procssing=true
    this.FlowcharPaper_Service.History_WorkFlow(this.Token,item.makerId).subscribe(
      data=>{
        this.Selected_History_Record=item
        this.DataList_History=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Close_Show_History(){
    this.Selected_History_Record=Empty_FlowchartPaper_Interface()
  }


}
